/**
 * BuildingConfigInfoColumn Configuration
 *
 * This object defines the configuration for a custom column in a table that displays building configuration information.
 *
 * Properties:
 * @property {string} id - The unique identifier for the column.
 * @property {boolean} sort - Indicates whether the column is sortable (false in this case).
 * @property {string} text - The display text for the column header.
 * @property {string} dataField - The field in the data source that this column maps to.
 * @property {function} formatter - A custom formatter function to format the data for display.
 *
 * Formatter Function:
 * The formatter function takes in the column data (col) and the row data (row) as parameters. It returns a JSX element
 * that displays the course and assignment information if available, otherwise, it displays "You".
 */

import { useUserContext } from "../../_runtime/iam/session.context";
import { FC } from "react";

export const BuildingConfigInfoColumn = {
  id: "custom",
  sort: false,
  text: "From",
  dataField: "course.name",
  formatter: (col: any, row: any) => (
    <BuildingConfigCreationInfoColumn row={row} />
  ),
};

const BuildingConfigCreationInfoColumn: FC<any> = ({ row }) => {
  const { userId, userRole } = useUserContext();
  const courseName = () => {
    if (row.assignment) {
      if (row.assignment !== null) {
        if (row.assignment.course !== null) return row.assignment.course.name;
        else return "";
      }
    }
    return "";
  };

  const assignmentName = () => {
    if (row.assignment && row.assignment !== null) {
      return row.assignment.title;
    }
    return "";
  };

  const getUser = () => {
    if (row.user !== null) {
      return row.user.id === userId ? "You" : row.user.displayName;
    }

    return "Student";
  };

  return (
    <>
      {row.assignment !== null
        ? `${courseName()} - ${assignmentName()}`
        : getUser()}
    </>
  );
};
